// extracted by mini-css-extract-plugin
export default {"PaginationWrapper":"Pagination_PaginationWrapper__O6PeC"};